import { enUS, ptBR, es, fr, Locale } from "date-fns/locale";

export function getDateFnsLocale(language: string): Locale {
  const lang = language?.split("-")[0]?.toLowerCase();

  switch (lang) {
    case "en":
      return enUS;
    case "pt":
      return ptBR;
    case "es":
      return es;
    case "fr":
      return fr;
    default:
      return ptBR; 
  }
}
